// extracted by mini-css-extract-plugin
module.exports = {"root":"Cart_root__1vBQE","left":"Cart_left__19MBW","right":"Cart_right__1fPAS","title":"Cart_title__36yYt"};